import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'gb-tip-icon',
  templateUrl: './gb-tip-icon.component.html',
  styleUrls: ['./gb-tip-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbTipIconComponent {
  @Input() circleColor = 'var(--gb-primary-color-800)'
  @Input() outlineColor = 'var(--gb-primary-color-100)'
  @Input() heartColor = 'var(--gb-primary-color-500)'
  @Input() sleeveColor = 'var(--gb-primary-color-500)'
  @Input() handColor = '#f3f3f3'

  getStyle(color: string) {
    return {
      fill: color,
    }
  }
}
